const ROLES = {
  CLIENT: 'client',
  ADMIN: 'administrator',
};

export default ROLES;
